<template>
  <div
    :class="['sf-loader']"
    v-bind="$attrs"
  >
    <transition
      name="sf-fade"
      mode="out-in"
    >
      <slot v-if="!loading" />
      <div
        v-else
        class="sf-loader__overlay"
      >
        <slot name="loader">
          <svg
            role="img"
            width="38"
            height="38"
            viewBox="0 0 38 38"
            xmlns="http://www.w3.org/2000/svg"
            class="sf-loader__spinner"
          >
            <title>Loading...</title>
            <g
              fill="none"
              fill-rule="evenodd"
            >
              <g
                transform="translate(1 1)"
                stroke-width="2"
              >
                <circle
                  stroke-opacity=".5"
                  cx="18"
                  cy="18"
                  r="18"
                />
                <path d="M36 18c0-9.94-8.06-18-18-18">
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 18 18"
                    to="360 18 18"
                    dur="1s"
                    repeatCount="indefinite"
                  />
                </path>
              </g>
            </g>
          </svg>
        </slot>
      </div>
    </transition>
  </div>
</template>
<script>

export default {
  name: 'SfLoader',
  props: {
    loading: {
      default: true,
      type: Boolean,
    },
  },
};

</script>
<style lang="scss">
.sf-loader {
  position: relative;
  width: 100%;
  height: 100%;

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--loader-overlay-background, var(--c-white));
  }

  &__spinner {
    stroke: var(--loader-spinner-stroke, var(--c-primary));
  }
}
</style>
